import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2" }
const _hoisted_2 = { class: "text-gray-900 font-semibold flex gap-2 flex-1" }
const _hoisted_3 = { class: "bg-yellow-500 text-white rounded-full p-1 w-6 h-6 text-sm flex items-center justify-center" }
const _hoisted_4 = { class: "ml-8" }

import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import { ChevronLeftIcon } from "@heroicons/vue/24/outline";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportFormSection',
  props: {
    number: {},
    label: {},
    defaultOpen: { type: Boolean, default: true }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Disclosure), {
      defaultOpen: !!_ctx.defaultOpen
    }, {
      default: _withCtx(({ open }) => [
        _createVNode(_unref(DisclosureButton), { class: "flex gap-2" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.number), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.label), 1)
            ]),
            _createVNode(_unref(ChevronLeftIcon), {
              class: _normalizeClass([{ '-rotate-90': open }, "w-5 h-5 shrink-0"])
            }, null, 8, ["class"])
          ]),
          _: 2
        }, 1024),
        _createVNode(_unref(DisclosurePanel), null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["defaultOpen"])
  ]))
}
}

})